import { firebaseShared } from "@shared/firebase.js";
import * as firebase from "@shared/firebase.js";
import * as environment from "@shared/environment.js";
import * as utility from "@shared/utility.js";
import { featuredCollWithID } from "@shared/featuredCollections.js";
import { dlog } from "@shared/utility.js";
import { t } from "@shared/i18n.js";

let allGalleryImages = []; // all feed items (with isLive=true) fetched from Firebase
let totalGalleryImageCnt = 0; // Total item cnt fetched from Firebase.

function galleryImageWithID(id) {
    return allGalleryImages.find(item => item.id === id);
}

function allGalleryImagesForFeaturedCollID(collID, limit = 999999) {
    if (collID === "everything") {
        return allGalleryImages.slice(0, limit);
    } else {
        const coll = featuredCollWithID(collID);

        // Filter and map items to match the order of collectionItemIDs, then apply the limit
        const filteredItems = coll.itemIDs.map(id => 
            allGalleryImages.find(item => item.id === id)
        ).filter(item => item !== undefined).slice(0, limit);
        
        return filteredItems;
    }
}

function allGalleryImagesCountForCollID(collID) {
    if (collID === "everything") {
        return allGalleryImages.length;
    } else {
        const coll = featuredCollWithID(collID);
        return coll.itemIDs.length;
    }
}

async function fetchGalleryImageFeed(force = false) {
    // Due to some weird firebase bug(?) where the auth token times out (I think in 30m), let's avoid trying to re-fetch feeds from firebase if we already have them.
    if (!force && allGalleryImages.length > 0) {
        dlog("already fetched gallery images. bailing.");
        return;
    }

    try {
        dlog(`fetchGalleryImageFeed: start; collection: ${environment.currentGalleryImageCollectionName()}`);
        
        const collectionRef = firebase.collection(firebaseShared.db, environment.currentGalleryImageCollectionName());
        dlog(`fetchGalleryImageFeed: got collectionRef`);
        
        const snapshot = await firebaseShared.withRetry(() => firebase.getDocs(collectionRef));
        dlog(`fetchGalleryImageFeed: got snapshot`);
        
        const tempGalleryImages = [];
        
        snapshot.forEach(doc => {
            const item = doc.data();
            if (item.isLive === true) {
                tempGalleryImages.push(item);
            } else {
                dlog(`ignoring disabled (isLive=false) item: ${item.id}`);
            }
        });
        
        if (tempGalleryImages.length === 0) {
            let blankItem = createNewGalleryImage();
            tempGalleryImages.push(blankItem);
        }

        utility.sortByModDate(tempGalleryImages);

        tempGalleryImages.forEach(item => {
            if (item.tags) {
                item.rawTags = item.tags;
                item.tags = item.tags.split(",")
                    .map(tag => t(`tags.${tag.trim()}`, { defaultValue: tag.trim() }))
                    .join(", ");
            }
        });

        allGalleryImages = tempGalleryImages;
        totalGalleryImageCnt = allGalleryImages.length;
        
        dlog("allGalleryImages count: " + allGalleryImages.length);
    } catch (error) {
        console.warn("fetchGalleryImageFeed failed after retries:", error);
        return;
    }
    
    dlog(`fetchGalleryImageFeed: ${allGalleryImages.length} items in collection`);
}

function createNewGalleryImage() {
    let newGalleryImage = {};
    newGalleryImage.id = randomString(12);
    newGalleryImage.imageID = "";
    newGalleryImage.tags = "";
    newGalleryImage.isLive = true;
    return newGalleryImage
}

export { allGalleryImages, totalGalleryImageCnt, galleryImageWithID, allGalleryImagesForFeaturedCollID, allGalleryImagesCountForCollID, fetchGalleryImageFeed };